import React, { useState } from 'react';
import { Popover } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const ChartInfoPopover = ({ title = 'Chart Guide', items = [], compact = false }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    return (
        <>
            <button
                type="button"
                className={`insights-chart-info-btn ${compact ? 'compact' : ''}`}
                onClick={(event) => {
                    event.stopPropagation();
                    setAnchorEl(event.currentTarget);
                }}
                aria-label="Chart information"
            >
                <InfoOutlinedIcon fontSize="inherit" />
            </button>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
                <div className="insights-chart-info-popover" onClick={(event) => event.stopPropagation()}>
                    <p className="insights-chart-info-title">{title}</p>
                    <div className="insights-chart-info-list">
                        {items.map((item) => (
                            <div key={item.label} className="insights-chart-info-item">
                                <span className={`insights-chart-info-marker ${item.type || 'line'}`} style={item.style || {}} />
                                <div>
                                    <p className="insights-chart-info-item-label">{item.label}</p>
                                    <p className="insights-chart-info-item-text">{item.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </Popover>
        </>
    );
};
